// src/routes/verifyOtpRoute.jsx
import VerifyOtp from '../pages/Auth/VerifyOtp';

export const verifyOtpRoute = {
  path: '/verify-otp',
  element: <VerifyOtp />
};